'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var itPeekable = require('it-peekable');

var browserStreamToIt = require('browser-readablestream-to-it');

var all = require('it-all');

var utils = require('./utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var itPeekable__default = /*#__PURE__*/_interopDefaultLegacy(itPeekable);

var browserStreamToIt__default = /*#__PURE__*/_interopDefaultLegacy(browserStreamToIt);

var all__default = /*#__PURE__*/_interopDefaultLegacy(all);

function normaliseContent(_x) {
  return _normaliseContent.apply(this, arguments);
}

function _normaliseContent() {
  _normaliseContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var peekable, _yield$peekable$peek, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!utils.isBytes(input)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", new Blob([input]));

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", new Blob([input.toString()]));

          case 4:
            if (!utils.isBlob(input)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", input);

          case 6:
            if (utils.isReadableStream(input)) {
              input = browserStreamToIt__default["default"](input);
            }

            if (!(Symbol.iterator in input || Symbol.asyncIterator in input)) {
              _context.next = 28;
              break;
            }

            peekable = itPeekable__default["default"](input);
            _context.next = 11;
            return peekable.peek();

          case 11:
            _yield$peekable$peek = _context.sent;
            value = _yield$peekable$peek.value;
            done = _yield$peekable$peek.done;

            if (!done) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", itToBlob(peekable));

          case 16:
            peekable.push(value);

            if (!Number.isInteger(value)) {
              _context.next = 26;
              break;
            }

            _context.t0 = Blob;
            _context.t1 = Uint8Array;
            _context.next = 22;
            return all__default["default"](peekable);

          case 22:
            _context.t2 = _context.sent;
            _context.t3 = _context.t1.from.call(_context.t1, _context.t2);
            _context.t4 = [_context.t3];
            return _context.abrupt("return", new _context.t0(_context.t4));

          case 26:
            if (!(utils.isBytes(value) || typeof value === 'string' || value instanceof String)) {
              _context.next = 28;
              break;
            }

            return _context.abrupt("return", itToBlob(peekable));

          case 28:
            throw errCode__default["default"](new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _normaliseContent.apply(this, arguments);
}

function itToBlob(_x2) {
  return _itToBlob.apply(this, arguments);
}

function _itToBlob() {
  _itToBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var parts, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parts = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 3;
            _iterator = _asyncIterator(stream);

          case 5:
            _context2.next = 7;
            return _iterator.next();

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 13;
              break;
            }

            chunk = _step.value;
            parts.push(chunk);

          case 10:
            _iteratorAbruptCompletion = false;
            _context2.next = 5;
            break;

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 19:
            _context2.prev = 19;
            _context2.prev = 20;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 24;
              break;
            }

            _context2.next = 24;
            return _iterator.return();

          case 24:
            _context2.prev = 24;

            if (!_didIteratorError) {
              _context2.next = 27;
              break;
            }

            throw _iteratorError;

          case 27:
            return _context2.finish(24);

          case 28:
            return _context2.finish(19);

          case 29:
            return _context2.abrupt("return", new Blob(parts));

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));
  return _itToBlob.apply(this, arguments);
}

exports.normaliseContent = normaliseContent;